module.exports = __webpack_public_path__ + "img/arc.4d4901cd.svg";